import React, {Component} from "react";
import {Button} from "primereact/button";
import {Growl} from 'primereact/growl';
import GuaranteesTableView from "./GuaranteesTableView";
import ConfirmationMessage from "../../../components/confirmationMessage"
import {GuaranteesTableService} from "../../../service/limitControl/GuaranteesTableService";
import ContextMenu from "../../../components/contextMenu";
import {CatalogService} from "../../../service/catalog/CatalogService";

export default class GuaranteesTableContainer extends Component {
    constructor(props) {
        super(props);

        this.guaranteesTableService = new GuaranteesTableService();
        this.catalogService = new CatalogService();
        this.getDataGuaranteesTable = this.getDataGuaranteesTable.bind(this);
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        }

        this.state = {
            dataGuaranteesTable: this.getDataGuaranteesTable(),
            rowSelected: {},
            isLoading: true,
        };

        this.updateAforo = this.updateAforo.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.deleteAforo = this.deleteAforo.bind(this);
        this.openEditDialog = this.openEditDialog.bind(this)
        this.onChangeValue = this.onChangeValue.bind(this);
        this.guaranteesTableActionTemplate = this.guaranteesTableActionTemplate.bind(this);
        this.loading = this.loading.bind(this);
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }


    getDataGuaranteesTable() {
        this.loading(true);
        return this.guaranteesTableService.getGuaranteeTableData()
            .then(dataTable => {
                this.setState({
                    dataGuaranteesTable: dataTable,
                });
                this.loading(false);
            });
    }

    /**
     *
     * @param rowData Cada una de las líneas del DataTable.
     * @returns {*} Template de la columna
     */
    formatDescription(rowData) {
        return (rowData['DescrAforo'] === "" ? "Capturar Aforo" : rowData['DescrAforo']);
    }

    openEditDialog(rowData) {
        rowData['actualInstitution'] = localStorage.getItem('institution');
        this.catalogService.getCatalogAforo()
            .then(catalogData => {
                    rowData['aforoObj'] = catalogData.find((item) =>
                        item['idTipoAforo'] === rowData['IdAforo']);
                    this.setState({
                        displayDialog: true,
                        rowSelected: rowData,
                        listAforos: catalogData,
                    });
                }
            )
    }

    updateAforo() {
        this.loading(true);
        if (this.state.rowSelected.aforoObj &&
            this.state.rowSelected.aforoObj.idTipoAforo) {
            this.guaranteesTableService.updateAforoInstitution(this.state.rowSelected)
                .then(resp => {
                    if (resp.message === "Success") {
                        this.growl.show({
                            severity: 'success', summary: 'Éxito.',
                            detail: 'Se ha guardado su solicitud con éxito.'
                        });
                        this.getDataGuaranteesTable();
                    } else if (resp.error !== '') {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: resp.error
                        });
                    }
                });
            this.loading(false);
            this.onHideDialog();
            this.setState({
                rowSelected: {},
            });

        } else {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Llenar el campo requerido'
            });
        }

    }

    deleteAforo() {
        this.loading(true);
        this.guaranteesTableService.deleteAforoInstitution(this.state.rowSelected)
            .then(resp => {
                if (resp.message === "Success") {
                    this.growl.show({
                        severity: 'success', summary: 'Éxito.',
                        detail: 'Se ha eliminado su solicitud con éxito.'
                    });
                    this.getDataGuaranteesTable();
                } else if (resp.error !== '') {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: resp.error
                    });
                }
            });
        this.loading(false);
        this.onHideDialog();
        this.setState({
            rowSelected: {},
        });

    }

    onHideDialog() {
        this.loading(false);
        this.setState({
            displayDialog: false,
            rowSelected: {},
        });
    }

    onChangeValue(event) {
        const {name, value} = event.target;
        let rowSelectedAux = this.state.rowSelected;
        rowSelectedAux[name] = value;
        this.setState({rowSelected: rowSelectedAux,})
    }

    /**
     * Función que contruye un template para la última columna de la tabla
     * donde se muestra un menú contextual con las opciones editar y eliminar.
     * @returns {html} Menú contextual (Editar, Eliminar)
     */
    guaranteesTableActionTemplate(rowData, column) {
        let optionsMenu = [{label: "Editar ", action: () => this.openEditDialog(rowData)},];
        if (rowData['DescrAforo'] !== "") {
            optionsMenu.push({label: "Eliminar", action: this.confirmationRef.openConfirmationMessage})
        }
        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    handleSelectRow = (event) => {
        this.setState({
            rowSelected: event.value,
        });
    };

    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Control de Límite \ Tabla de Garantía \ Editar</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Regresar"
                            onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Guardar"
                            onClick={this.updateAforo}/>
                </div>
            </div>;

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Está seguro que desea eliminar el aforo de la institución?"
                                            action={this.deleteAforo}/>;

        const {dataGuaranteesTable, displayDialog, isLoading, rowSelected, listAforos} = this.state;

        return <GuaranteesTableView dataGuaranteesTable={dataGuaranteesTable}
                                    dialogHeader={dialogHeader}
                                    displayDialog={displayDialog}
                                    isLoading={isLoading}
                                    messagesGrowl={messagesGrowl}
                                    rowSelected={rowSelected}
                                    listAforos={listAforos}
                                    confirmationMessage={this.confMsg}
                                    getDataGuaranteesTable={this.getDataGuaranteesTable}
                                    formatDescription={this.formatDescription}
                                    openEditDialog={this.openEditDialog}
                                    onHideDialog={this.onHideDialog}
                                    guaranteesTableActionTemplate={this.guaranteesTableActionTemplate}
                                    onChangeValue={this.onChangeValue}
                                    handleSelectRow={this.handleSelectRow}
        />
    }
};